var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.467,
    height: 19.45,
    viewBox: "661.767 60.783 19.467 19.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon-Set"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "folder-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M679.812 66.937h-16.625v-3.562c0-.655.533-1.188 1.188-1.188h3.562c.656 0 1.188.533 1.188 1.188v1.187h9.5c.655 0 1.187.532 1.187 1.188v1.187Zm0 10.688c0 .655-.532 1.187-1.187 1.187h-14.25a1.188 1.188 0 0 1-1.188-1.187v-9.5h16.625v9.5Zm-1.187-14.25h-8.313A2.375 2.375 0 0 0 667.937 61h-3.562A2.375 2.375 0 0 0 662 63.375v14.25A2.375 2.375 0 0 0 664.375 80h14.25A2.375 2.375 0 0 0 681 77.625V65.75a2.375 2.375 0 0 0-2.375-2.375Z",
    fill: "#1785d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.812 66.937h-16.625v-3.562c0-.655.533-1.188 1.188-1.188h3.562c.656 0 1.188.533 1.188 1.188v1.187h9.5c.655 0 1.187.532 1.187 1.188v1.187h0Zm0 10.688c0 .655-.532 1.187-1.187 1.187h-14.25a1.188 1.188 0 0 1-1.188-1.187v-9.5h16.625v9.5h0Zm-1.187-14.25h-8.313A2.375 2.375 0 0 0 667.937 61h-3.562A2.375 2.375 0 0 0 662 63.375v14.25A2.375 2.375 0 0 0 664.375 80h14.25A2.375 2.375 0 0 0 681 77.625V65.75a2.375 2.375 0 0 0-2.375-2.375h0Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    stroke: "#1785d6",
    fill: "transparent"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuIcon);
export default __webpack_public_path__ + "static/media/ou-icon.f8e9c34f5d3788a90da290b9066b97fc.svg";
export { ForwardRef as ReactComponent };